<script>
export default {
    props: {
        action: {}
    },
    computed: {
        type() {
            if (this.action !== null) {
                if (this.action.action_type == 1) {
                    return this.$t("project_actions.status");
                } else {
                    return this.$t("project_actions.task");
                }
            } else {
                return "";
            }
        }
    }
};
</script>

<template>
    <div
        class="action-viewer"
        :class="action !== null ? 'action-viewer-loaded' : ''"
    >
        <template v-if="action !== null">
            <div class="av_type">
                <span>{{ type }}:</span> {{ action.user.name }}
            </div>
            <div class="av_notes">{{ action.notes }}</div>
        </template>
    </div>
</template>

<style lang="scss">
.action-viewer {
    &-loaded {
        border: 1px solid $gray-300;
        border-radius: 6px;
        padding: 15px;
    }

    .av_type {
        font-size: 13px;
        span {
            font-weight: bold;
        }
    }

    .av_notes {
        margin-top: 10px;
        padding-top: 10px;
        border-top: 1px solid $gray-300;
        font-size: 12px;
    }
}
</style>
